module.exports = __webpack_public_path__ + "static/screenshot4-8724eef920aeefee1398f46fdfd30088.png";